import { render, staticRenderFns } from "./no-access.vue?vue&type=template&id=6f99d6b4&scoped=true&"
import script from "./no-access.vue?vue&type=script&lang=js&"
export * from "./no-access.vue?vue&type=script&lang=js&"
import style0 from "./no-access.vue?vue&type=style&index=0&id=6f99d6b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99d6b4",
  null
  
)

export default component.exports